import styled from 'styled-components';
import { media } from '../../../../../helpers/breakpoints';
import Text from '../../../../ToolkitV2/Text/Text';

export const Title = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  /* Allow this div to collapse to support truncation within flex children */
  min-width: 0;
`;

export const Container = styled.div<{ isGrid?: boolean }>`
  ${({ theme }) => theme.fontSize.M16};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S12};
  padding: ${({ theme, isGrid }) =>
    `${isGrid ? theme.spacing.S12 : theme.spacing.S8} ${theme.spacing.M16}`};
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.GREY_LIGHT}`};
  height: ${({ theme }) => theme.spacing.XL64};

  ${media.medium} {
    padding: ${({ theme }) => `${theme.spacing.S12} ${theme.spacing.M24}`};
  }
`;

export const Logo = styled.img`
  height: ${({ theme }) => theme.spacing.L48};
  width: ${({ theme }) => theme.spacing.L48};
  min-width: ${({ theme }) => theme.spacing.L48};
`;
